<div class="queue-utilities" data-layout="row" data-layout-align="space-between center">
  <button mat-flat-button color="vdt-primary"
          (click)="removeCompletedFax()"
          [disabled]="selectedFax.length == 0"
          matTooltip="Remove Completed"
          matTooltipPosition="below"
          matTooltipClass="tooltip"
          aria-label="Remove Completed">
    Remove: {{ selectedFax.length }}
  </button>
  <div data-layout="row" data-layout-align="space-between center">
    <span class="count">Showing: <span class="nowrap">{{ faxesCount }}</span></span>
    <app-refresh (iconClick)="refreshQueue()" [title]="refreshTitleText"></app-refresh>
  </div>
  <button mat-icon-button title="Filter queue" (click)="openFilterDialog()" matTooltipClass="multiline-tooltip" matTooltip="{{filterBadgeData.text}}">
    <mat-icon matBadge={{filterBadgeData.count}}
              matBadgeColor="warn"
              matBadgeSize="small"
              class="material-icons-outlined icon-dark"
              aria-hidden="false"
              aria-label="Filter queue"
              [matBadgeHidden]="filterBadgeData.count==0">
      filter_list
    </mat-icon>
  </button>
  <span class="cdk-visually-hidden">
    Notification icon with overlaid badge showing the number {{filterBadgeData.count}}
  </span>
</div>
<cdk-virtual-scroll-viewport name="teamFaxes" itemSize="10" autosize style="height: calc(100vh - 250px)">
  <div *cdkVirtualFor="let item of queues" class="nowrap">
    <app-fax-queue [item]="item" [isSelectable]="false" [canBeLocked]="false"
      (removeFaxes)="removeFaxEvent($event)"></app-fax-queue>
  </div>
</cdk-virtual-scroll-viewport>

<!-- dialog content: Filter Faxes -->
<ng-template #filterFaxDialogTemplate>
  <form [formGroup]="dateRangeFaxTeamQueue">
    <div class="mb-3">
      <lib-vdt-datepicker calendarId="mfqReceivedDateRangePicker" 
        placeholderText="Received Date Range"
        [showDateRange]="true" 
        [(dateRange)]="receivedDateRange" 
        [showTime]="false" 
        [readonlyInput] = "true"
        [styleClass]="'full-width'"
        (dateRangeChange)="dateRangeChanged($event, 'mfqReceivedDates')">
      </lib-vdt-datepicker>
    </div>
    <hr />
    <mat-form-field class="full-width" appearance="fill" *ngIf="faxView != 1">
      <mat-label>Work Queue</mat-label>
      <mat-select formControlName="faxQueue"
                  (openedChange)="filterFaxQ.value=''">
        <input matInput placeholder="Search" #filterFaxQ>
        <div *ngFor="let a of faxQueues">
          <mat-option [value]="a.queueId" *ngIf="a.queueName.toLowerCase().includes((filterFaxQ.value).toLowerCase())">{{ a.queueName }}</mat-option>
        </div>
      </mat-select>
    </mat-form-field>
  </form>
</ng-template>
